const queryString = require('query-string');

class Filters {
	constructor($container) {
		this.$container = $container;
		this.$filterTabs = this.$container.find('.component__tab-filters');
		this.$filterPagination = this.$container.find('.component__pagination');
		this.queryParamTab = 'tab';
		this.queryParamPage = 'page';
	}

	create() {
		const parsedUrl = queryString.parseUrl(window.location.href);

		if (parsedUrl.query[this.queryParamTab]) {
			const $tab = this.$filterTabs.find(`.js-component-filter[data-filter-value="${parsedUrl.query[this.queryParamTab]}"]`);
			this.tabsUpdate(null, $tab)
		}

		if (parsedUrl.query[this.queryParamPage]) {
			const $page = this.$filterPagination.find(`.js-component-filter[data-filter-value="${parsedUrl.query[this.queryParamPage]}"]`);
			this.paginationUpdate(null, $page)
		}

		this.$filterPagination
			.on('click', '.js-component-filter', (e) => this.paginationUpdate(e));

		this.$filterTabs
			.on('click', '.js-component-filter', (e) => this.tabsUpdate(e));
	}

	paginationUpdate(e, $page = null) {
		if (!$page) {
            e.preventDefault();
			$page = $(e.target);
        }

		let $parent = $page.closest('.pagination__item'),
			$container = $page.closest('.component__pagination'),
			$active = $container.find('.pagination__link--active');

		$active.removeClass('pagination__link--active');
		if ($parent.hasClass('pagination__item--prev')) {
			if ($(window).outerWidth() <= 768) {
				$active
					.closest('.pagination__item')
					.prev()
					.find('.pagination__link')
					.addClass('pagination__link--active');
			}
		} else if ($parent.hasClass('pagination__item--next')) {
			$active
				.closest('.pagination__item')
				.next()
				.find('.pagination__link')
				.addClass('pagination__link--active');
		} else {
			$page.addClass('pagination__link--active');
		}

		let contentOffset = this.$container.offset().top - 100;
		$('body').velocity('scroll', {duration: 500, offset: contentOffset});
		
	}

	tabsUpdate(e, $tab = null) {
        if (!$tab) {
            e.preventDefault();
			$tab = $(e.target);
        }

        const $container = $tab.closest('.component__tab-filters');
        const $activeTab = $container.find('.tab-filters__link--active');

        $activeTab.removeClass('tab-filters__link--active');
        $tab.addClass('tab-filters__link--active');
	}
}

if ($('.js-component').length) {
	let filters = new Filters($('.js-component'));
	filters.create();
}



// WEBPACK FOOTER //
// ./frontend/components/filters/filters.js